import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { performancemaster } from './../../models/admin';
import { UtilityService } from './../../services/utility.service';
import { AdminApiService } from './../../services/admin.service';
import { BMApiService } from './../../services/bm.service';
import { SpinnerVisibilityService } from 'ng-http-loader';
import Swal from 'sweetalert2'
import { UserService } from './../../services/user.service';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { uniqBy } from 'lodash';
import {
  AngularGridInstance,
  Column,
  FieldType,
  Filters,
  Formatter,
  GridOption,
  FileType,
  Formatters,

} from 'angular-slickgrid';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { surveyQuestionMaster, surveyQuestionEntry, surveyOptionMaster, bmincomingattendees, bmsurveyQAList } from './../../models/slakpi';
declare var google: any;
@Component({
  selector: 'app-survey-report',
  templateUrl: './survey-report.component.html',
  styleUrls: ['./survey-report.component.css']
})
export class SurveyReportComponent implements OnInit {
 

  visitTrackUno: any;
  attendeeID: any;
  reportCount_data: any;
  objSurveyReportList: any = [];
  angularGrid: AngularGridInstance;
  columnDefinitions: Column[];
  gridOptions: GridOption;
  dataset: any;
  login_UserID: any;
  userList: any;
  constructor(private formBuilder: FormBuilder, private _activatedRoute: ActivatedRoute, public restBMApi: BMApiService, public restApi: AdminApiService, private route: ActivatedRoute, public utilityService: UtilityService, private router: Router, private spinner: SpinnerVisibilityService, private userService: UserService, private modalService: BsModalService) {
    this.userList = this.userService.getUserInfo();
    this.login_UserID = this.userList.id;
  }

  ngOnInit() {

    this._activatedRoute.params.subscribe((params: Params) => {
      
      if (params['id'] != null) {
        this.visitTrackUno = params['id'];
        this.getAttendee(this.visitTrackUno);
        this.getSurveyReportList();
      }
    });
    
    this.gridOptions = {
      autoHeight: true,
      enableAutoResize: true,
      enablePagination: true,
      pagination: {
        pageSizes: [5, 10, 20, 50, 100, 500],
        pageSize: 20
      },
      enableFiltering: true,
      alwaysShowVerticalScroll: false,
      enableRowSelection: true,
      autoResize: {
        containerId: 'musherat-grid',
        delay: 0,
        sidePadding: 10,
        bottomPadding: 10
      },
      enableExcelExport: true,
      enableExcelCopyBuffer: true,
      enableFilterTrimWhiteSpace: true,
      showCustomFooter: true, // display some metrics in the bottom custom footer
      enableContextMenu: true,
      enableCellMenu: true,
      forceFitColumns: true,

    };
  }

  angularGridReady(angularGrid: AngularGridInstance) {
    this.angularGrid = angularGrid;
    this.userService.angularGrid = angularGrid;
  }

  setColnDefn() {
    let temp = this;
    this.columnDefinitions = [

      {
        id: 'question', name: 'Question', field: 'question', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'question', 'question'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'option1', name: 'Option 1', field: 'option1', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'option1', 'option1'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'option2', name: 'Option 2', field: 'option2', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'option2', 'option2'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'option3', name: 'Option 3', field: 'option3', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'option3', 'option3'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'option4', name: 'Option 4', field: 'option4', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'option4', 'option4'),
          model: Filters.multipleSelect,

        }
      },
      {
        id: 'option5', name: 'Option 5', field: 'option5', sortable: true, type: FieldType.string, filterable: true, width: 150,
        filter: {
          collection: this.uniqueArray(this.dataset, 'option5', 'option5'),
          model: Filters.multipleSelect,

        }
      },
    ]


  }
  exportToExcel() {
    var temp = this;
    setTimeout(function () {
      temp.angularGrid.excelExportService.exportToExcel({
        filename: 'Export',
        format: FileType.xlsx,

      });
    }, 100)
    return false;

  }
  uniqueArray(arrayList, val, label) {
    var temp = this;
    var aList = [];
    if (arrayList) {
      for (var i = 0, l = arrayList.length; i < l; i++)
        if (aList.filter(item => item.label == temp.Checklabel(arrayList[i][label])).length == 0) {

          aList.push({
            'value': this.CheckValue(arrayList[i][val]), 'label': this.Checklabel(arrayList[i][label])
          });
        }
    }


    aList.sort((a: any, b: any) => {
      if (a['value'] < b['value']) {
        return -1;
      } else if (a['value'] > b['value']) {
        return 1;
      } else {
        return 0;
      }
    });
    return aList;
  }

  Checklabel(val) {
    if (val != undefined && val != null && val != '' && val != ' ')
      return val.trim();
    else
      return ''

  }

  CheckValue(val) {
    if (val != undefined && val != null && val != '' && val != ':')
      return val;
    else
      return ' ';

  }

  IsNull(val) {
    if (val != undefined && val != null && val != '') {
      val = val.trim()
      return val.charAt(0).toUpperCase() + val.slice(1);
    }
    else
      return ' ';

  }



  

  getAttendee(id) {
    let inpValue = new bmincomingattendees();
    inpValue.visitTrackUno = id;
    inpValue.condition = 2;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getBMIncomingAtd(inpValue)
      .subscribe(data => {
        //this.datasetAtd = data;
        
        let rtn_data: any = data;
        if (rtn_data != null && rtn_data.length > 0) {
          this.reportCount_data = rtn_data[0];
          this.reportCount_data.completetionCount = ((parseInt(this.reportCount_data.completedCount) / parseInt(this.reportCount_data.startedCount)) * 100).toFixed(2);
          this.reportCount_data.completetionCount = (this.reportCount_data.completetionCount = 'NaN') ? 0 : this.reportCount_data.completetionCount;
        }
        //this.setAtdDefn();
      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });
  }

  getSurveyReportList() {

    let inpValue = new bmsurveyQAList();
    inpValue.bmIncomingUno = this.visitTrackUno;
    inpValue.userUno = this.login_UserID;
    this.restBMApi.getBMIncomingSurveyReport(inpValue)
      .subscribe(data => {
        
        this.objSurveyReportList = data;

         //Survey Chart -- start
        this.spinner.show();
        setTimeout(() => {
         
          if (this.objSurveyReportList.length > 0) {
            google.charts.load('current', { 'packages': ['corechart'] });
            for (var i = 0; i < this.objSurveyReportList.length; i++) {
              
              google.charts.setOnLoadCallback(this.surveyChart(this.objSurveyReportList[i].options, ("surveyChart"+i), this.objSurveyReportList[i].question));
            }

          }
          this.spinner.hide();
        }, 1500);

         //Survey Chart -- end

        //Export Excel -- start
        const mockDataset = [];
        for (let i = 0; i < this.objSurveyReportList.length; i++) {
          mockDataset[i] = {
            id: this.objSurveyReportList[i].questionUno,
            question: this.objSurveyReportList[i].question,
            option1: this.getOptionName(this.objSurveyReportList[i].options, 0),
            option2: this.getOptionName(this.objSurveyReportList[i].options, 1),
            option3: this.getOptionName(this.objSurveyReportList[i].options, 2),
            option4: this.getOptionName(this.objSurveyReportList[i].options, 3),
            option5: this.getOptionName(this.objSurveyReportList[i].options, 4)
          };
        }
        this.dataset = mockDataset;
        if (mockDataset.length > 0) {
          this.setColnDefn();
        }

         //Export Excel -- end

      },
        (error) => {
          //Called when error
        }
      ).add(() => {
        //Called when operation is complete (both success and error)
      });


  }
 getOptionName(option_data: any, id: any)
 {
   let name = '';
   for (var i = 0; i < option_data.length; i++) {
     if (id == i) {
       name = option_data[i].optionText;
       break;
     }
   }
   return name;
 }
  surveyChart = (option_data: any, divid: any,strTitle:string) => {
    
    let tempArray = [['Option', 'Value']];
    for (var i = 0; i < option_data.length; i++) {
      tempArray.push([option_data[i].optionText, option_data[i].count]);
    }
    const data = google.visualization.arrayToDataTable(tempArray);
    /*[
      ['Sample size', 'positioning'],
      ['Top Decile', 11],
      ['Top Quartile', 2],
      ['Median', 2],
      ['Bottom Quartile', 2]


    ]*/
    const options = {
      title:'',// strTitle,
      pieHole: 0.4,
      chartArea: { left: 10, top: 50, bottom: 10, width: "100%", height: "100%" },
      colors: ['#006600', '#339933', '#ffc000', '#c00000']
    };

    const chart = new google.visualization.PieChart(document.getElementById(divid));
    chart.draw(data, options);
  }



}
